<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount, ref, reactive, computed } from "vue";
import { useStore } from "vuex";

import ProfileCard from "./components/ProfileCard.vue";

const store = useStore();

import { useI18n } from "vue-i18n";

// 引入i18n用于国际化
const { t } = useI18n();

import {
  userInfo,
  updateUser,
  updateUserPassword,
  validateSms,
  sendSms,
  pageApiList,
  deleteApicredentials, enableOrDisable, creteaAicredentials, updateMobile
} from "@/api/user";
import { ElMessage } from "element-plus";
const ruleFormRef = ref()

const user = ref(null)

// 更新，绑定手机号
const updatePhoneNumberTitle = ref('')
const phoneNumberDialogVisible = ref(false)
const phoneForm = reactive({
  mobile: null,
  scene: null,
  code: null
})
const currentScene = ref(2)

const countdown = ref(60); // 倒计时秒数
const isCounting = ref(false); // 是否在倒计时



const phoneRules = computed(() => ({
  mobile: [
    { required: true, message: t('profile.enterNumber'), trigger: 'blur' },
    { pattern: /^\+?[1-9]\d{1,14}$/, message: t('profile.enterValidNumber'), trigger: 'blur' }
  ],
  code: [
    { required: true, message: t('profile.enterVerificationCode'), trigger: 'blur' }
  ]
}))

const phoneFormRef = ref(null);

const getVerificationCode = (mobile) => {
  if (isCounting.value) return;
  isCounting.value = true;
  countdown.value = 60;

  const interval = setInterval(() => {
    if (countdown.value === 0) {
      clearInterval(interval);
      isCounting.value = false;
    } else {
      countdown.value--;
    }
  }, 1000);

  // 模拟发送验证码的逻辑
  if (mobile) {
    const data = {
      mobile: mobile,
      scene: currentScene.value
    }
    sendSms(data).then(res => {
      console.log(' = res sendSms', res)

    }).catch(err => {
      console.log('err sendSms', err)
    })
  }
};

const myAPPForm = reactive({
  name: ''
})

const myAppRulesForm = computed(() => ({
  name: [
    { required: true, message: t('profile.enterNickname'), trigger: 'blur' },
  ]
}))

const myAPPDialogVisible = ref(false)

const ruleForm = ref({
  id: '',
  nickname: '',
  email: '',
  mobile: '',

})


const rules = computed(() => ({
  nickname: [
    { required: true, message: t('profile.enterNickname'), trigger: 'blur' },
  ],
  email: [
    { required: true, message: t('profile.enterEmail'), trigger: 'blur' },
    { type: 'email', message: t('profile.validEmail'), trigger: ['blur', 'change'] },
  ],
  mobile: [
    { required: true, message: t('profile.enterNumber'), trigger: 'blur' },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: t('profile.enterValidNumber'),
      trigger: ['blur', 'change'],
    },
  ],
}));

// 用户信息
const getUserInfo = () => {
  userInfo().then(res => {
    // 只保留需要的字段
    const { id = '', nickname = '', email = '', mobile = '' } = res.data;
    user.value = { id, nickname, email, mobile };
    ruleForm.value = { id, nickname, email, mobile };
  })
}

const activeName = ref('first')
const handleClick = (tab) => {
  if (tab.props.name === 'myApp') {
    getApiList({})
  }
}

const certificate = ref()

// api 凭证 列表
const getApiList = (params) => {
  pageApiList(params).then(res => {
    certificate.value = res.data
  })
}

// 删除key

const confirmEventKey = (row) => {
  deleteApicredentials({ id: row.id }).then(() => {
    getApiList({})
  }).catch(err => {
    console.log(' = delete key', err)
  })
  console.log('confirm!')
}
// 取消删除
const cancelEventKey = () => {
  console.log('cancel!')
}

// 执行开启，停用key
const confirmEventEnabled = (row) => {

  const data = {
    id: row.id
  }
  enableOrDisable(data).then(() => {
    getApiList({})
  }).catch(err => {
    console.log('err', err)
  })
}

const cancelEventEnabled = () => {
  console.log('cancel!')
}


// 分页
const tabPageApi = (e) => {
  console.log(' = e 当前页', e)
  getApiList({ pageNo: e })
}


const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      updateUser(ruleForm.value).then(res => {
        store.dispatch('setUserInfo'); // 从 store 中获取用户信息
        ElMessage({
          message: t('profile.modifySuccessfully'),
          type: 'success',
        })
        getUserInfo()

        if (profileCard.value) {
          profileCard.value.getUserInfo()
        }

        phoneNumberDialogVisible.value = false
      }).catch(err => {
        ElMessage({
          message: t('profile.failModify'),
          type: 'error',
        })
      })
      console.log('submit!', ruleForm.value)
    } else {
      console.log('error submit!', fields)
    }
  })
}


const passwordFormRef = ref(null);
const passwordForm = reactive({
  code: '',
  newPassword: '',
  confirmPassword: '',
});

const passwordRules = computed(() => ({
  code: [
    { required: true, message: t('profile.enterVerificationCode'), trigger: 'blur' },
  ],
  newPassword: [
    { required: true, message: t('profile.enterNewPassword'), trigger: 'blur' },
    { min: 6, message: t('profile.characters'), trigger: 'blur' },
  ],
  confirmPassword: [
    { required: true, message: t('profile.confirmNewPassword'), trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== passwordForm.newPassword) {
          callback(new Error(t('twoPasswordsDifferent')));
        } else {
          callback();
        }
      },
      trigger: 'blur',
    },
  ],
}))


const submitPasswordForm = async (formEl) => {

  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      updateUserPassword({
        code: passwordForm.code,
        password: passwordForm.newPassword,
      })
        .then((response) => {
          ElMessage.success(t('profile.passwordSuccessfully'));
        })
        .catch((error) => {
          console.error('修改密码失败:', error);
          ElMessage.error('profile.failedPassword');
        });
    } else {
      console.error('验证失败', fields);
    }
  })
};
const myAPPFormRef = ref(null)
const onMyappSubmit = async (formEl) => {

  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log('submit!')
      const data = {
        name: myAPPForm.name
      }
      creteaAicredentials(data).then(() => {
        myAPPDialogVisible.value = false
        ElMessage({
          message: t('alarm.success'),
          type: 'success',
        })
        getApiList({})
      }).catch(err => {
        console.log(' = err', err)
      })


    } else {
      console.log('error submit!', fields)
    }
  })


}

// 更新手机号
const updatePhoneNumber = () => {
  updatePhoneNumberTitle.value = t('profile.updatePhoneNumber')
  phoneNumberDialogVisible.value = true
  phoneForm.mobile = ruleForm.value.mobile
  // 更新手机号，场景为
  currentScene.value = 2

}



const submitMobileCode = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log('submit!')
      phoneForm.scene = currentScene.value

      // 修改手机号
      if (updatePhoneNumberTitle.value === t('profile.updatePhoneNumber')) {
        updateMobile(phoneForm).then(res => {
          console.log(' = res', res)
          ElMessage({
            message: 'success',
            type: 'success',
          })
          phoneNumberDialogVisible.value = false
          getUserInfo()
          if (profileCard.value) {
            profileCard.value.getUserInfo()
          }
        }).catch(err => {
          console.log(' err', err)
          ElMessage({
            message: 'fail',
            type: 'warning',
          })
        })
      }


      // 绑定手机号
      if (updatePhoneNumberTitle.value === t('profile.bindPhoneNumber')) {
        validateSms(phoneForm).then(res => {
          console.log(' = res', res)
          ElMessage({
            message: 'success',
            type: 'success',
          })
          phoneNumberDialogVisible.value = false
          getUserInfo()
          if (profileCard.value) {
            profileCard.value.getUserInfo()
          }
        }).catch(err => {
          console.log(' err', err)
          ElMessage({
            message: 'fail',
            type: 'warning',
          })
        })
      }

    } else {
      console.log('error submit!', fields)
    }
  })
}

// bindMobile 绑定手机号 使用场景2
const bindMobile = () => {
  currentScene.value = 2
  phoneNumberDialogVisible.value = true
  updatePhoneNumberTitle.value = t('profile.bindPhoneNumber')
}


onMounted(() => {
  // store.state.isAbsolute = true;
  // setNavPills();
  // setTooltip();
  getUserInfo()
});

const profileCard = ref(null)

</script>
<template>

  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-4">
        <profile-card ref="profileCard" />
      </div>
      <div class="col-md-8">
        <div class="card p-3">
          <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
            <el-tab-pane :label="$t('profile.essentialInformation')" name="first">
              <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" class="demo-form-inline">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item :label="$t('profile.nickname')" prop="nickname" label-position="top"
                      class="form-item-top">
                      <el-input v-model="ruleForm.nickname" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item v-if="ruleForm.mobile" :label="$t('profile.phoneNumber')" prop="mobile"
                      label-position="top" class="form-item-top">
                      <el-input v-model="ruleForm.mobile" disabled>
                        <template #append>
                          <el-button type="primary" @click="updatePhoneNumber">{{ $t('profile.update') }}</el-button>
                        </template>
                      </el-input>
                    </el-form-item>

                    <el-form-item v-if="!ruleForm.mobile" :label="$t('profile.phoneNumber')" prop="mobile"
                      label-position="top" class="form-item-top">
                      <el-button type="primary" @click="bindMobile">{{ $t('profile.bindPhoneNumber') }}</el-button>
                    </el-form-item>

                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item :label="$t('profile.userMailbox')" prop="email" label-position="top"
                      class="form-item-top">
                      <el-input v-model="ruleForm.email" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">

                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">

                    <el-form-item>

                      <el-button type="primary" @click="submitForm(ruleFormRef)">
                        {{ $t('group.submit') }}
                      </el-button>
                    </el-form-item>
                  </el-col>

                </el-row>

              </el-form>
            </el-tab-pane>
            <el-tab-pane :label="$t('profile.changePassword')" name="second">
              <el-form ref="passwordFormRef" :model="passwordForm" :rules="passwordRules" class="demo-form-inline">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item :label="$t('profile.newPassword')" prop="newPassword" label-position="top"
                      class="form-item-top">
                      <el-input v-model="passwordForm.newPassword" type="password" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('profile.confirmNewPasswordLabel')" prop="confirmPassword"
                      label-position="top" class="form-item-top">
                      <el-input v-model="passwordForm.confirmPassword" type="password" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item :label="$t('profile.verificationCode')" prop="code" label-position="top"
                      class="form-item-top">
                      <el-input v-if="ruleForm.mobile" v-model="passwordForm.code">
                        <template #append>
                          <el-button :disabled="isCounting" @click="getVerificationCode(ruleForm.mobile)"
                            style="margin-left: 10px">
                            {{ isCounting ? `${countdown}秒` : '获取验证码' }}
                          </el-button>
                        </template>
                      </el-input>
                      <el-button v-if="!ruleForm.mobile" type="primary"
                        @click="bindMobile">{{ $t('profile.bindPhoneNumber') }}</el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item>
                      <el-button type="primary" @click="submitPasswordForm(passwordFormRef)">
                        {{ $t('group.submit') }}
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>

            </el-tab-pane>
            <el-tab-pane :label="$t('profile.myAPP')" name="myApp">
              <el-table v-if="certificate && certificate.list" :data="certificate.list" border style="width: 100%">
                <el-table-column prop="name" :label="$t('profile.applicationName')" />
                <el-table-column prop="appKey" :label="$t('profile.key')" />
                <el-table-column prop="enabled" :label="$t('profile.status')">
                  <template v-slot:default="scope">
                    <el-link type="success" v-if="scope.row.enabled === 1">{{ $t('profile.open') }}</el-link>
                    <el-link v-if="scope.row.enabled === 0">{{ $t('profile.close') }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="" :label="$t('device.operation')">
                  <template v-slot:default="scope">

                    <el-popconfirm :confirm-button-text="$t('group.confirm')" :cancel-button-text="$t('group.cancel')"
                      icon-color="#626AEF" :title="$t('notification.sureDelete')" @confirm="confirmEventKey(scope.row)"
                      @cancel="cancelEventKey">
                      <template #reference>
                        <el-link type="danger">{{ $t('alarm.delete') }}</el-link>
                      </template>
                    </el-popconfirm>

                    <el-popconfirm :confirm-button-text="$t('group.confirm')" :cancel-button-text="$t('group.cancel')"
                      icon-color="#626AEF" :title="$t('profile.sureChange')" @confirm="confirmEventEnabled(scope.row)"
                      @cancel="cancelEventEnabled">
                      <template #reference>
                        <el-link class="m-2" type="primary">{{ scope.row.enabled === 1 ? $t('profile.close') :
                          $t('profile.open')}}</el-link>
                      </template>
                    </el-popconfirm>

                  </template>
                </el-table-column>

              </el-table>

              <div class="m-2">
                <el-pagination background layout="prev, pager, next" v-if="certificate && certificate.total"
                  :total="certificate.total" @current-change="tabPageApi" />
              </div>

              <el-button class="mt-5" plain @click="myAPPDialogVisible = true">
                {{ $t('alarm.add') }}
              </el-button>

              <el-dialog v-model="myAPPDialogVisible" :title="$t('alarm.add')" width="50%">

                <el-form :model="myAPPForm" ref="myAPPFormRef" :rules="myAppRulesForm" label-width="auto"
                  style="max-width: 600px">
                  <el-form-item :label="$t('profile.applicationName')" prop="name">
                    <el-input v-model="myAPPForm.name" />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="onMyappSubmit(myAPPFormRef)">{{ $t('group.submit') }}</el-button>
                    <el-button @click="myAPPDialogVisible = false">{{ $t('group.cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
            </el-tab-pane>
          </el-tabs>

          <el-dialog v-model="phoneNumberDialogVisible" :title="updatePhoneNumberTitle" width="50%">

            <el-form ref="phoneFormRef" :model="phoneForm" :rules="phoneRules" label-width="auto"
              style="max-width: 600px">
              <el-form-item :label="$t('notification.phoneMessage')" prop="mobile">
                <el-input v-model="phoneForm.mobile">
                  <template #append>
                    <el-button :disabled="isCounting" @click="getVerificationCode(phoneForm.mobile)"
                      style="margin-left: 10px">
                      {{ isCounting ? `${countdown}` + $t('alarm.second') : $t('profile.getCode') }}
                    </el-button>
                  </template>
                </el-input>

              </el-form-item>
              <el-form-item :label="$t('profile.verificationCode')" prop="code">
                <el-input v-model="phoneForm.code" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitMobileCode(phoneFormRef)">{{ $t('group.submit') }}</el-button>
                <el-button @click="phoneNumberDialogVisible = false">{{ $t('group.cancel') }}</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.el-form-item.form-item-top {
  margin-bottom: 20px;
}

.el-form-item.form-item-top .el-form-item__label {
  text-align: left;
}
</style>
